module.exports = __webpack_public_path__ + "img/littleImg10.f57be3ed.gif";